/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Modified By: rogerk
 * Created On: July 15th, 2018
 * Last Modified: July 15th, 2018
 * ****************************************************************************
 */
import * as React from 'react';
import { ChessRenderInfo } from 'components/board/chessTypes';
import { RenderPieceFunction } from 'components';

const piece_icon_map = {
  k: 'king',
  q: 'queen',
  b: 'bishop',
  n: 'knight',
  r: 'rook',
  p: 'pawn',
};


function _renderChessPiece(info: ChessRenderInfo): React.ReactNode {
  const { square, piece, size } = info;
  const { width, height } = size;

  if (!piece) {
    return null;
  }

  const clr = piece.color === 'w' ? 'white' : 'black';
  let padding = 10;
  if (info.size.height < 50 || info.size.width < 50) {
    padding = 5;
  }
  const calcHeight = (height - (padding * 2));

  return (
    <div
      className={`fas fa-chess-${piece_icon_map[piece.type]} piece ${clr}-piece`}
      style={{
        padding: padding + 'px',
        fontSize: calcHeight + 'px',
        lineHeight: calcHeight + 'px',
        width: width + 'px',
        height: height + 'px',
      }}
    />
  );
}

const renderChessPiece: RenderPieceFunction = _renderChessPiece;
export default renderChessPiece;



// WEBPACK FOOTER //
// ./src/app/renderChessPiece.tsx